module.exports = __webpack_public_path__ + "img/otto-logo-title-white.f2fb6831.svg";